export type ThemeMode = "light" | "dark" | "system";

const STORAGE_KEY = "rest.theme";

export function readMode(): ThemeMode {
  const v = localStorage.getItem(STORAGE_KEY);
  return v === "light" || v === "dark" || v === "system" ? v : "system";
}

export function systemPrefersDark(): boolean {
  return window.matchMedia?.("(prefers-color-scheme: dark)").matches ?? false;
}

export function effectiveTheme(mode: ThemeMode): "light" | "dark" {
  if (mode === "system") return systemPrefersDark() ? "dark" : "light";
  return mode;
}

export function applyTheme(mode: ThemeMode): void {
  const eff = effectiveTheme(mode);
  const html = document.documentElement;
  html.classList.toggle("dark", eff === "dark");
  html.classList.toggle("light", eff === "light");
  const meta = document.querySelector('meta[name="theme-color"]');
  if (meta) meta.setAttribute("content", eff === "dark" ? "#0a0b0d" : "#ffffff");
}

export function setMode(mode: ThemeMode): void {
  localStorage.setItem(STORAGE_KEY, mode);
  applyTheme(mode);
}

export function initTheme(): () => void {
  applyTheme(readMode());
  const mq = window.matchMedia?.("(prefers-color-scheme: dark)");
  const handler = () => {
    if (readMode() === "system") applyTheme("system");
  };
  mq?.addEventListener?.("change", handler);
  return () => mq?.removeEventListener?.("change", handler);
}
